export const GETUSER = 'GETUSER';
export const EMPTYUSERINFO = 'EMPTYUSERINFO';
export const GETADDRESSINFO = 'GETADDRESSINFO';
export const GETUSERID = 'GETUSERID';



// WEBPACK FOOTER //
// ./src/store/types.js